module.exports = __webpack_public_path__ + "media/hind/Hind-Medium-3f38f3a4.woff2";